import { render, staticRenderFns } from "./ChangeContactInfo.vue?vue&type=template&id=b45a129a&scoped=true"
import script from "./ChangeContactInfo.vue?vue&type=script&lang=js"
export * from "./ChangeContactInfo.vue?vue&type=script&lang=js"
import style0 from "./ChangeContactInfo.vue?vue&type=style&index=0&id=b45a129a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45a129a",
  null
  
)

export default component.exports